module.exports = __webpack_public_path__ + "static/media/photo36.62ebaf95.jpg";